import { filterTabs } from '../components/PowertrainAssetDetails/constants';

export const togglePowertrainAssets = (translate) => [
    { label: translate('ABB.Powertrain.Frontend.powertrainsLabel'), value: filterTabs.POWERTRAINS },
    { label: translate('ABB.Powertrain.Frontend.ttl_Assets'), value: filterTabs.ASSETS }
];
